import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  testimonialItem: {
    padding: '15px',
    // minHeight: '240px',
    [theme.breakpoints.up('md')]: {
      padding: '20px',
    },
  },
  clientName: {
    fontSize: '1.25rem',
    fontWeight: '700',
    fontFamily: 'Lato',
    color: '#000',
    marginBottom: '5px',
  },
  commentDate: {
    fontSize: '0.75rem',
    fontWeight: '400',
    fontFamily: 'Lato',
    marginBottom: '10px',
  },
  clientComment: {
    fontSize: '1rem',
    fontWeight: '400',
    fontFamily: 'Lato',
    marginBottom: '10px',
  },
}));
